/**
 * @file BlogFeedHeaderField.tsx
 * @description «Шапка ленты» в панели «Блог → Лента» (phase19.16 Р2;
 * решение пользователя 2026-10-11): [Встроенная][Своя] (`options.feedHeader`).
 * «Своя» — встроенная шапка не показывается, её собирают блоком над лентой:
 * кнопка открывает место «Над лентой блога» и окно заготовок с группой
 * «Блог» первой (там «Шапка ленты блога»).
 *
 * SB122: поле стоит в группе «Шапка ленты» — подпись даёт заголовок группы,
 * своей `Label` у поля нет.
 */

import type { SiteBlogOptions } from "@chaiberi/shared";

import { Button } from "../../ui/button";
import { Segmented } from "../Segmented";
import { useOpenSlot } from "../../../hooks/site-builder/useOpenSlot";

const OPTIONS = [
  { value: "builtin" as const, label: "Встроенная" },
  { value: "custom" as const, label: "Своя" },
];

interface Props {
  value: SiteBlogOptions["feedHeader"];
  onChange: (value: SiteBlogOptions["feedHeader"]) => void;
}

export function BlogFeedHeaderField({ value, onChange }: Props) {
  const openSlot = useOpenSlot();
  return (
    <div className="flex flex-col gap-2">
      <Segmented aria-label="Шапка ленты" options={OPTIONS} value={value} onChange={onChange} />
      {value === "custom" ? (
        <div className="flex flex-col items-start gap-2 rounded-lg bg-surface-low px-3 py-2">
          <p className="type-caption text-on-surface-variant">
            Встроенная шапка не показывается. Соберите свою блоком над лентой: заготовка «Шапка ленты блога» или любая секция.
            Своя шапка заменит встроенную на сайте после публикации вида; до этого на сайте видны обе — опубликуйте вид сразу после сборки.
          </p>
          {openSlot ? (
            <Button variant="outline" onClick={() => void openSlot("BLOG_FEED_ABOVE", { group: "blog" })}>
              Добавить блок над лентой ›
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
